import { Component, ViewEncapsulation, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalTitleButton } from './modal-title-button.type';

@Component({
  selector: 'shared-modal',
  templateUrl: 'modal.component.html',
  styleUrls: ['modal.component.scss'],
  host: { class: 'modal-body' },
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ModalComponent implements AfterViewInit {
  @Input() modalTitle: string;
  @Input() modalIcon: string;
  @Input() titleButtons: ModalTitleButton[] = [];
  @Input() showFooter = false;
  @Input() showSpinner = false;

  @ViewChild('modalHeader', { static: true }) modalHeader: ElementRef<HTMLElement>;
  @ViewChild('modalTitleButtons', { static: true }) modalTitleButtonsElement: ElementRef<HTMLElement>;

  constructor(private _activeModal: NgbActiveModal) {}

  ngAfterViewInit(): void {
    const modalTitleButtonsWidth = this.modalTitleButtonsElement.nativeElement.offsetWidth;
    const modalHeaderElement = this.modalHeader.nativeElement;

    const h3Element = modalHeaderElement.querySelector('h3');
    if (h3Element) {
      h3Element.style.width = `calc(100% - ${modalTitleButtonsWidth}px)`;
    }
  }

  close(result?: any): void {
    this._activeModal.close(result);
  }
}
